var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2690_8824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9H18V6C18 2.691 15.309 0 12 0C8.691 0 6 2.691 6 6V9H5.25C4.65351 9.00079 4.08167 9.2381 3.65989 9.65989C3.2381 10.0817 3.00079 10.6535 3 11.25V21.75C3 22.991 4.01 24 5.25 24H18.75C19.99 24 21 22.991 21 21.75V11.25C21 10.009 19.99 9 18.75 9ZM8 6C8 3.794 9.794 2 12 2C14.206 2 16 3.794 16 6V9H8V6ZM13 16.722V19C13 19.2652 12.8946 19.5196 12.7071 19.7071C12.5196 19.8946 12.2652 20 12 20C11.7348 20 11.4804 19.8946 11.2929 19.7071C11.1054 19.5196 11 19.2652 11 19V16.722C10.405 16.375 10 15.737 10 15C10 13.897 10.897 13 12 13C13.103 13 14 13.897 14 15C14 15.737 13.595 16.375 13 16.722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2690_8824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.641b761308f030b455da5bb6793d0840.svg";
export { ForwardRef as ReactComponent };